<!-- <ngx-spinner></ngx-spinner> -->
<router-outlet></router-outlet>

<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.75)"
  size="large"
  [fullScreen]="true"
  type="ball-scale-multiple"
  template="
    <div class='spinner-wrapper' style= 'display: flex; flex-direction: column; align-items: center; justify-content: center;'>
      <img
        src='assets/img/portrait/small/quintus.png'
        alt='Quintus Logo'
        class='spinner-logo'
        style='width: 80px;'
      />
      <p class='spinner-text' style='color: #fff; margin-top: 20px; text-align: center;'>
        Please Wait Until your request has not completed...
      </p>
    </div>
  "
>
</ngx-spinner>
